<template>
   <div v-if="showAutoAuthorizeSettings">
        <h2 class="title">Invoice Settings</h2>
        <loading v-if="loading"></loading>
        <form v-else @submit.prevent="updateInvoiceSettings('invoice')" data-vv-scope="invoice">
            <h2>Auto Authorize Orders For Payment</h2>
            <p class="is-size-7 m-t-sm">When new orders are imported would you like {{this.$store.state.dealer_portal.settings.brand_name}} to be able to charge you for the order immediately?</p>
            <div class="buttons has-addons m-t-sm">
                <button
                    type="button"
                    class="button"
                    :class="{ 'is-link' : !booleanTypeTruthy(invoiceSettings.auto_authorize.value) }"
                    @click="invoiceSettings.auto_authorize.value = false"
                >
                    No
                </button>
                <button
                    type="button"
                    class="button"
                    :class="{ 'is-link' : booleanTypeTruthy(invoiceSettings.auto_authorize.value) }"
                    @click="invoiceSettings.auto_authorize.value = true"
                >
                    Yes
                </button>
            </div>

            <div v-if="invoiceSettings.auto_authorize.value">
                <h4>Only Auto Authorize Up To A Maximum Order Total</h4>
                <p class="is-size-7 m-t-sm">When using auto authorize you can <b>optionally</b> set a maximum order total that once orders surpass they will no longer be auto authorized</p>
                <div class="field has-addons m-t-sm">
                    <p class="control">
                        <a class="button is-static">
                            <default-currency-symbol/>
                        </a>
                    </p>
                    <div class="control">
                        <input
                            class="input"
                            v-validate="'numeric'"
                            name="up_to"
                            v-model="invoiceSettings.auto_authorize_up_to.value"
                            placeholder="The optional maximum order total"
                        />
                        <div v-show="errors.has('invoice.up_to')" class="help is-danger">Must be a valid number</div>
                    </div>
                </div>
            </div>

            <div class="m-t-lg">
                <button class="button is-primary" :class="{ 'is-loading' : saving }" type="submit">
                    Update Invoice Settings
                </button>
            </div>

        </form>
   </div>
</template>

<script>
import DealerSettingsApi from '../../../api/DealerSettings';
import settingValueParser from '../../../util/SettingValueParser';

import EventBus from '../../../event-bus';
import DefaultCurrencySymbol from "../../../elements/DefaultCurrencySymbol";

export default {
    name : "InvoiceSettings",
    components : {DefaultCurrencySymbol},
    data () {
        return {
            loading : true,
            saving : false,
            invoiceSettings : {
                auto_authorize : {},
                auto_authorize_up_to : {},
            },
        };
    },
    beforeMount () {


        DealerSettingsApi.get(Object.keys(this.invoiceSettings)).then(response => {
            this.prepAndSetSettings(response.data);

            EventBus.on(EventBus.EVENT.ALL_PAYMENTS_DELETED, () => {
                this.invoiceSettings.auto_authorize.value = false;
            });

            this.loading = false;
        });


    },
    computed : {
        showAutoAuthorizeSettings () {
            //if this is true, means no auto authorize setting will be visible in dealer portal and all the orders will be auto authorize.
            return !this.$store.state.dealer_portal.settings['hide_auth_settings_and_auto_authorized'];
        },
    },
    methods : {

        prepAndSetSettings (settings) {
            settings.forEach(s => {
                this.invoiceSettings[s.handle] = {
                    ...s,
                    value : settingValueParser(s.valueType, s.value),
                };
            });
        },

        async updateInvoiceSettings (validate) {

            const valid = await this.$validator.validateAll(validate);

            if(!valid){
                this.$notify({
                    text : 'Please fix the errors listed in red and try again',
                    type : 'error',
                });
                return;
            }

            this.saving = true;

            DealerSettingsApi.saveSettings(Object.values(this.invoiceSettings)).then(response => {
                this.prepAndSetSettings(response.data);
                this.$notify({
                    text : 'Invoice Settings Updated!',
                });
            }).finally(() => {
                this.saving = false;
            });

        },

        booleanTypeTruthy (value) {
            return value === true || value === 'true';
        },

    },
}
</script>

<style scoped>

</style>
